/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  BuildOutlined,
  CalendarOutlined,
  DeleteOutlined,
  EditOutlined,
  KeyOutlined,
  MailOutlined,
  MobileOutlined,
  PlusOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from "@ant-design/icons";
import {
  Alert,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Badge,
} from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import {
  addAPIAccount,
  deleteAPIAccount,
  updateAPIAccount,
  updateUser,
  validateConcurrentLogin,
} from "../../../Actions/api";
import NeedAuthService from "../../../Services/needAuth.service";
import "./Profile.css";
import { CHART_COLORS, transparentize } from "./utils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function Profile() {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const date = new Date();

  const [month, day, year] = [
    date.getMonth(),
    date.getDate(),
    date.getFullYear(),
  ];
  var months = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
  ];
  const today = year + "-" + months[month] + "-" + day;
  const [chartStartDateTime, setChartStartDateTime] = useState(today);
  const [chartEndDateTime, setChartEndDateTime] = useState(today);
  const history = useHistory();

  const getUser = () => {
    var UserArray = [];
    var PartnerArray = [];
    NeedAuthService.getUser().then((response) => {
      var userId = response.Data.UserId;
      var userName = response.Data.UserName;
      var mobile = response.Data.Mobile;
      var email = response.Data.Email;
      var partnerId = response.Data.PartnerId;
      var PartnerName = response.Data.PartnerName;
      var PartnerEmail = response.Data.PartnerEmail;
      var PartnerMobile = response.Data.PartnerMobile;
      var PartnerICNO = response.Data.PartnerICNO;
      var agentId = response.Data.AgentId;
      var isInternalUser = response.Data.IsInternalUser;
      UserArray.push({
        userId: userId,
        userName: userName,
        mobile: mobile,
        email: email,
      });
      PartnerArray.push({
        name: PartnerName,
        email: PartnerEmail,
        mobile: PartnerMobile,
        ICNO: PartnerICNO,
      });

      setUser(UserArray);
      setPartner(PartnerArray);
      setAgentId(agentId);
      setPartnerId(partnerId);
      setLoading1(false);
      setLoading2(false);
      getCategory(partnerId);
      setIsPrivate(isInternalUser);

      if(response.Succeeded){
        NeedAuthService.getLoginAccountList(partnerId).then((response) => {
          setLoginAccountList(response.Data);
          setLoading5(false);
        })
      }
    });

  };


  const getCategory = async (partnerId) => {
    var CategoryArray = [];
    var array = [];
    var finalArray = [];
    NeedAuthService.getCategory(partnerId, 0).then((response) => {
      for (var i = 0; i <= response.Data.length - 1; i++) {
        var name = response.Data[i].Name;
        var id = response.Data[i].Id;
        var agentType = response.Data[i].AgentType;
        CategoryArray.push({ name: name, id: id, agentType: agentType });
        if (!array.includes(agentType)) {
          array.push(agentType);
        }
      }
      if (array.includes(1)) {
        finalArray.push({
          value: "1",
          name: "General Insurance",
        });
      }
      if (array.includes(2)) {
        finalArray.push({
          value: "2",
          name: "Integral Life",
        });
      }
      if (array.includes(3)) {
        finalArray.push({
          value: "3",
          name: "Common Service",
        });
      }
      setATSelection(finalArray);
      setCategory(CategoryArray);
      getAPIAccount(partnerId);
    });
  };

  const getAPIAccount = (partnerId) => {
    var APIAccountArray = [];
    NeedAuthService.getAPIAccount(partnerId).then((response) => {
      for (var i = 0; i <= response.Data.length - 1; i++) {
        var id = response.Data[i].Id;
        var apiUserName = response.Data[i].APIUserName;
        var apiKey = response.Data[i].APIKey;
        var productAccount = response.Data[i].ProductAccount;
        var agentType = response.Data[i].AgentType;
        APIAccountArray.push({
          id: id,
          apiUserName: apiUserName,
          apiKey: apiKey,
          key: i + 1,
          productAccount: productAccount,
          agentType: agentType,
        });
      }
      setAPIAccount(APIAccountArray);
      setLoading3(false);
      getAPIPortalLogInCategory(
        partnerId,
        chartStartDateTime,
        chartEndDateTime
      );
    });
  };

  const getAPIPortalLogInCategory = (partnerId, StartDate, EndDate) => {
    var chartLabel = [];
    var usage = [];
    var failure = [];
    var ProductList = [];
    NeedAuthService.getAPIPortalLogInCategory(
      partnerId,
      StartDate,
      EndDate
    ).then((response) => {
      for (var i = 0; i <= response.Data.length - 1; i++) {
        var CategoryName = response.Data[i].APIProductCategoryName;
        var usageNum = response.Data[i].Usage;
        var failureNum = response.Data[i].Failure;
        var list = response.Data[i].APIProductList;
        for (var m = 0; m <= list.length - 1; m++) {
          ProductList.push({
            CategoryName: CategoryName,
            Name: list[m].APIProductName,
            Usage: list[m].ProductUsage,
            Failure: list[m].ProductFailure,
          });
        }
        chartLabel.push(CategoryName);
        usage.push(usageNum);
        failure.push(failureNum);
      }
      setChartLabel(chartLabel);
      setUsage(usage);
      setFailure(failure);
      setAPIProductList(ProductList);
      setLoading4(false);
    });
  };

  const getAPIPortalLogInAccount = (id, StartDate, EndDate) => {
    var chartLabel = [];
    var usage = [];
    var failure = [];
    var ProductList = [];

    NeedAuthService.getAPIPortalLogInAccount(id, StartDate, EndDate).then(
      (response) => {
        for (var i = 0; i <= response.Data.length - 1; i++) {
          var CategoryName = response.Data[i].APIProductCategoryName;
          var usageNum = response.Data[i].Usage;
          var failureNum = response.Data[i].Failure;
          var list = response.Data[i].APIProductList;
          for (var m = 0; m <= list.length - 1; m++) {
            ProductList.push({
              CategoryName: CategoryName,
              Name: list[m].APIProductName,
              Usage: list[m].ProductUsage,
              Failure: list[m].ProductFailure,
            });
          }
          chartLabel.push(CategoryName);
          usage.push(usageNum);
          failure.push(failureNum);
        }
        setChartLabel(chartLabel);
        setUsage(usage);
        setFailure(failure);
        setAPIProductList(ProductList);
        setLoading4(false);
      }
    );
  };

  useEffect(() => {
    if (!isLoggedIn) {
      history.push("/Login");
    }
    getUser();
  }, [isLoggedIn]);

  const [userInfo, setUser] = useState([
    { userId: "", userName: "", mobile: "", email: "" },
  ]);
  const [partnerInfo, setPartner] = useState([
    { name: "", email: "", mobile: "", ICNO: "" },
  ]);
  const [APIAccountInfo, setAPIAccount] = useState([]);
  const [PartnerIdInfo, setPartnerId] = useState(0);
  const [LoginAccountList, setLoginAccountList] = useState([]);
  const [AgentId, setAgentId] = useState(0);
  const [categoryInfo, setCategory] = useState([]);
  const [categoryInfoAT, setCategoryAT] = useState([]);
  const [PA, showPA] = useState(false);
  const [count, setCount] = useState(0);
  const [actionId, setActionId] = useState(0);
  const [actionName, setActionName] = useState("");
  const [, setIsPrivate] = useState(false);
  const { message } = useSelector((state) => state.message);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [updateModalVisible, handleUpdateModalVisible] = useState(false);
  const [deleteModalVisible, handleDeleteModalVisible] = useState(false);
  const [ATSelection, setATSelection] = useState([]);

  const [chartLabel, setChartLabel] = useState([]);
  const [usageData, setUsage] = useState([]);
  const [failureData, setFailure] = useState([]);
  const [APIProductList, setAPIProductList] = useState([]);
  const [chartType, setChartType] = useState("Category");

  //loading
  const [loading1, setLoading1] = useState(true);
  const [loading2, setLoading2] = useState(true);
  const [loading3, setLoading3] = useState(true);
  const [loading4, setLoading4] = useState(true);
  const [loading5, setLoading5] = useState(true);

  const [visible, setVisible] = useState(true);

  const [form] = Form.useForm();
  const [AddForm] = Form.useForm();
  const [UpdateForm] = Form.useForm();
  const dispatch = useDispatch();

  const showModal = () => {
    form.setFieldsValue({
      userId: userInfo[0].userId,
      userName: userInfo[0].userName,
      email: userInfo[0].email,
      mobile: userInfo[0].mobile,
    });
    setIsModalVisible(true);
  };

  const handleConcurrentLogin = (userId) => {
    let concurrencyLoginStamp = localStorage.getItem("ConcurrencyLoginStamp");
    if (concurrencyLoginStamp) {
      dispatch(validateConcurrentLogin(userId, concurrencyLoginStamp));
    }
  };

  const onUserEdit = (values) => {
    handleConcurrentLogin(values.userId);
    dispatch(
      updateUser(values.userId, values.userName, values.mobile, values.email)
    ).then(() => {
      setLoading1(true);
      getUser();
    });
    setIsModalVisible(false);
  };
  const getAPPId = () => {
    var userName = userInfo[0].userName;
    AddForm.setFieldsValue({
      apiUserName: userName + "-" + (APIAccountInfo.length + 1),
    });
  };

  const getKey = () => {
    var random = uuidv4().split("-");
    var key = "";
    for (var i = 0; i <= random.length - 1; i++) {
      key += random[i];
    }
    AddForm.setFieldsValue({
      apiKey: key,
    });
  };

  const showUpdateModalVisible = async (values) => {
    handleUpdateModalVisible(true);
    setCount(count + 1);
    var split = values.productAccount.split(",");
    var AT = values.agentType;
    // var partnerId = values.partnerId;
    var array = [];
    var CategoryArray = [];
    for (var m = 0; m <= categoryInfo.length - 1; m++) {
      var name = categoryInfo[m].name;
      var id = categoryInfo[m].id;
      var agentType = categoryInfo[m].agentType;
      if (agentType === AT) {
        CategoryArray.push({
          name: name,
          id: count + "/" + id,
          agentType: agentType,
        });
      }
      var match = split.indexOf(name.toString());
      if (match >= 0) {
        array.push(count + "/" + id);
      }
    }
    setCategoryAT(CategoryArray);
    setActionId(values.id);
    var ATName = "Integral Life";
    if (AT === 1) {
      ATName = "General Insurance";
    }
    UpdateForm.setFieldsValue({
      apiUserName: values.apiUserName,
      apiKey: values.apiKey,
      productAccount: array,
      agentType: ATName,
    });
  };

  const onUpdate = (values) => {
    handleConcurrentLogin(userInfo[0].userId);
    var ProductAccount = values.productAccount;
    var stringPA = "";
    for (var i = 0; i <= ProductAccount.length - 1; i++) {
      var string = ProductAccount[i].split("/");
      stringPA += string[1] + ",";
    }
    dispatch(
      updateAPIAccount(actionId, values.apiUserName, values.apiKey, stringPA)
    ).then(() => {
      setLoading3(true);
      getAPIAccount(PartnerIdInfo);
    });
    handleUpdateModalVisible(false);
  };

  const showDeleteModalVisible = async (values) => {
    setActionId(values.id);
    setActionName(values.apiUserName);
    handleDeleteModalVisible(true);
  };


  const onChangeProductPartnerFollowAT = (value) => {
    var array = [];
    if (value !== undefined) {
      setCount(count + 1);
      for (var m = 0; m <= categoryInfo.length - 1; m++) {
        var name = categoryInfo[m].name;
        var id = categoryInfo[m].id;
        var agentType = categoryInfo[m].agentType;
        var number = parseInt(value);
        if (number === agentType) {
          array.push({
            name: name,
            id: count + "/" + id,
            agentType: agentType,
          });
        }
        setCategoryAT(array);
      }
      showPA(true);
    } else {
      showPA(false);
    }
  };

  const columns = [
    {
      title: "No",
      dataIndex: "key",
    },
    {
      title: "APP ID",
      dataIndex: "apiUserName",
      key: "apiUserName",
    },
    {
      title: "Secret Key",
      dataIndex: "apiKey",
      key: "apiKey",
    },
    {
      title: "Product Account",
      dataIndex: "productAccount",
      key: "ProductAccount",
    }
  ];

  const option = categoryInfoAT.map((value) => (
    <Col span={8} key={value.id}>
      <Checkbox value={value.id}>{value.name}</Checkbox>
    </Col>
  ));

  //chart

  const { RangePicker } = DatePicker;
  const { Option, OptGroup } = Select;
  const dateFormat = "YYYY-MM-DD";

  const changeDate = (values, dateString) => {
    handleConcurrentLogin(userInfo[0].userId);
    setChartStartDateTime(dateString[0]);
    setChartEndDateTime(dateString[1]);
    setLoading4(true);
    if (chartType === "Category") {
      getAPIPortalLogInCategory(PartnerIdInfo, dateString[0], dateString[1]);
    } else {
      getAPIPortalLogInAccount(chartType, dateString[0], dateString[1]);
    }
  };

  const changeChart = (values) => {
    handleConcurrentLogin(userInfo[0].userId);
    setChartType(values);
    setLoading4(true);
    if (values === "Category") {
      getAPIPortalLogInCategory(
        PartnerIdInfo,
        chartStartDateTime,
        chartEndDateTime
      );
    } else {
      getAPIPortalLogInAccount(values, chartStartDateTime, chartEndDateTime);
    }
  };

  const state = {
    labels: chartLabel,
    datasets: [
      {
        label: "Usage",
        borderColor: CHART_COLORS.blue,
        backgroundColor: transparentize(CHART_COLORS.blue, 0.5),
        data: usageData,
      },
      {
        label: "Failure",
        borderColor: CHART_COLORS.red,
        backgroundColor: transparentize(CHART_COLORS.red, 0.5),
        data: failureData,
      },
    ],
  };

  // const agentType = [
  //   {
  //     "value": "1",
  //     "name": "General Insurance"
  //   },
  //   {
  //     "value": "2",
  //     "name": "Integral Life"
  //   }
  // ]

  // const isPrivateAgentType = [
  //   {
  //     "value": "1",
  //     "name": "General Insurance"
  //   },
  //   {
  //     "value": "2",
  //     "name": "Integral Life"
  //   },
  //   {
  //     "value": "3",
  //     "name": "Common Service"
  //   },
  // ]

  return (
    <div className="Profile-container" justify="center">
      <div className="Profile-title">Profile</div>
      {message && (
        <div>
          <Row justify="center" gutter={[12, 24]}>
            <Col xs={24} md={20}>
              {message[0] === true ? (
                <Alert message={message[1]} type="success" />
              ) : (
                <Alert
                  message={
                    message[1] != null ? (
                      message[1]
                    ) : (
                      <ul style={{ paddingLeft: "20px" }}>
                        {message[2].map((m) => (
                          <li key={m}>{m}</li>
                        ))}
                      </ul>
                    )
                  }
                  type="error"
                />
              )}
            </Col>
            <Col xs={24} sm={24} md={24} lg={2} xl={2}></Col>
          </Row>
          <br />
        </div>
      )}
      <div>
        <Row justify="center" gutter={[12, 24]}>
          <Col xs={24} md={20}>
            <Alert
              message="Informational Notes"
              description={
                <>
                  Please contact us at{" "}
                  <a href="mailto:customer.service@etiqa.com.sg">
                    customer.service@etiqa.com.sg
                  </a>{" "}
                  if you require more login accounts to access this portal.
                </>
              }
              type="info"
              showIcon
              closable
              banner
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={2} xl={2}></Col>
          <Col xs={22} sm={22} md={22} lg={6} xl={6}>
            <div className="user_information">
              <p className="Profile-subtitle">User Information</p>
              {loading1 === false ? (
                <div>
                  <Row gutter={12}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <p className="InfoLabel"> Username</p>
                      <p className="InfoDetail">
                        {" "}
                        <UserOutlined className="InfoIcon" />{" "}
                        {userInfo[0].userName}
                      </p>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <p className="InfoLabel"> Mobile</p>
                      <p className="InfoDetail">
                        <MobileOutlined className="InfoIcon" />{" "}
                        {userInfo[0].mobile}
                      </p>
                    </Col>
                  </Row>
                  <Row gutter={12} justify="end">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <Button style={{ float: "right" }} onClick={showModal}>
                        <EditOutlined /> Edit
                      </Button>
                    </Col>
                  </Row>
                </div>
              ) : (
                <div style={{ textAlign: "center", margin: "30% 0%" }}>
                  <Spin spinning={loading1}></Spin>
                </div>
              )}
            </div>
            <div className="entity_information">
              <p className="Profile-subtitle">Entity Information</p>
              {loading2 === false ? (
                <div>
                  <Row gutter={12}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <p className="InfoLabel">Name</p>
                      <p className="InfoDetail">
                        <UserOutlined className="InfoIcon" />{" "}
                        {partnerInfo[0].name}
                      </p>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <p className="InfoLabel">Email</p>
                      <p className="InfoDetail">
                        <MailOutlined className="InfoIcon" />{" "}
                        {partnerInfo[0].email}
                      </p>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <p className="InfoLabel"> Mobile</p>
                      <p className="InfoDetail">
                        <MobileOutlined className="InfoIcon" />{" "}
                        {partnerInfo[0].mobile}
                      </p>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <p className="InfoLabel"> Registration No</p>
                      <p className="InfoDetail">
                        <BuildOutlined className="InfoIcon" />{" "}
                        {partnerInfo[0].ICNO}
                      </p>
                    </Col>
                  </Row>
                </div>
              ) : (
                <div style={{ textAlign: "center", margin: "30% 0%" }}>
                  <Spin spinning={loading2}></Spin>
                </div>
              )}
            </div>
            <div className="loginAccount_information">
              <p className="Profile-subtitle">Login Account List</p>
              {loading5 === false ? (
                <div>
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                      <p className="InfoLabel">Email</p>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                      <p className="InfoLabel">Status</p>
                    </Col>
                  </Row>
                  {LoginAccountList.map((data) => {
                    return(
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12} xl={12}>{data.UserEmail}</Col>
                      <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        {!data.EmailConfirmed && <Badge status="processing" text="Pending"/>}
                        {(data.EmailConfirmed && data.IsDelete) && <Badge status="error" text="Inactivated"/>}
                        {(data.EmailConfirmed && !data.IsDelete) && <Badge status="success" text="Activated"/>}
                      </Col>
                    </Row>)
                  })}
                </div>
              ) : (
                <div style={{ textAlign: "center", margin: "30% 0%" }}>
                  <Spin spinning={loading5}></Spin>
                </div>
              )}
            </div>
          </Col>
          <Col xs={22} sm={22} md={22} lg={14} xl={14}>
            <div className="api_sandbox_information">
              <p className="Profile-subtitle">
                APIs Sandbox Account
                {/*<Button className="AddApiAccountButton" onClick={showAddModal}>*/}
                {/*  <PlusOutlined />*/}
                {/*  Add*/}
                {/*</Button>*/}
              </p>
              <Table
                columns={columns}
                dataSource={APIAccountInfo}
                scroll={{ x: "fit-content" }}
                loading={loading3}
                rowKey={"apiUserName"}
              />
            </div>
            <div className="data_information">
              <p className="Profile-subtitle">Data Visualisation</p>
              <Form layout="vertical">
                <Row>
                  <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                    <Input.Group compact size="large">
                      <div className="icon_selection">
                        {<UnorderedListOutlined />}
                      </div>
                      <Form.Item className="inputSelection">
                        <Select
                          style={{ width: "100%" }}
                          size="large"
                          onChange={changeChart}
                          defaultValue="Category"
                        >
                          <Option value="Category">API Product Category</Option>
                          <OptGroup label="Accounts">
                            {APIAccountInfo.map((option) => (
                              <Option value={option.id} key={option.id}>
                                {option.apiUserName}
                              </Option>
                            ))}
                          </OptGroup>
                        </Select>
                      </Form.Item>
                    </Input.Group>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                    <Input.Group compact size="large">
                      <div className="icon_selection">
                        {<CalendarOutlined />}
                      </div>
                      <Form.Item className="inputSelection">
                        <RangePicker
                          style={{ width: "100%" }}
                          onChange={changeDate}
                          size="large"
                          defaultValue={[
                            moment(today, dateFormat),
                            moment(today, dateFormat),
                          ]}
                        />
                      </Form.Item>
                    </Input.Group>
                  </Col>
                </Row>
              </Form>
              {loading4 === false ? (
                <div>
                  <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <p className="data_information_subtitle">Chart</p>
                      <Bar
                        data={state}
                        options={{
                          title: {
                            display: true,
                            text: "Average Rainfall per month",
                            fontSize: 12,
                          },
                          legend: {
                            display: true,
                            position: "top",
                          },
                        }}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <br />
                      <p className="data_information_subtitle">Listing</p>
                      <div className="RankingDiv">
                        <table className="RankingTable">
                          {chartLabel.map((label) => (
                            <React.Fragment key={label}>
                              <tr>
                                <td
                                  style={{
                                    width: "50%",
                                    backgroundColor: "#f2f2f2",
                                  }}
                                >
                                  <b>{label}</b>
                                </td>
                                <td style={{ backgroundColor: "#f2f2f2" }}>
                                  <b>Usage</b>
                                </td>
                                <td style={{ backgroundColor: "#f2f2f2" }}>
                                  <b>Failure</b>
                                </td>
                              </tr>
                              {APIProductList.map((list) => {
                                return list.CategoryName === label
                                  ? [
                                      <tr key={list.Name}>
                                        <td>{list.Name}</td>
                                        <td>{list.Usage}</td>
                                        <td>{list.Failure}</td>
                                      </tr>,
                                    ]
                                  : "";
                              })}
                            </React.Fragment>
                          ))}
                        </table>
                      </div>
                    </Col>
                  </Row>
                </div>
              ) : (
                <div style={{ textAlign: "center", margin: "30% 0%" }}>
                  <Spin spinning={loading4}></Spin>
                </div>
              )}
            </div>
          </Col>
          <Col xs={22} sm={22} md={22} lg={2} xl={2}></Col>
        </Row>
      </div>
      <Modal
        title="Update User Information"
        visible={isModalVisible}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              form.resetFields();
              onUserEdit(values);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
        onCancel={() => setIsModalVisible(false)}
      >
        <Form form={form} layout="vertical" name="form_in_modal">
          <Form.Item
            name="userName"
            label={<label className="label_login">UserName</label>}
            rules={[
              {
                required: true,
                message: "UserName is required",
              },
            ]}
          >
            <Input addonBefore={<UserOutlined />} size="large" placeholder="" />
          </Form.Item>
          <Form.Item name="userId" hidden>
            <Input />
          </Form.Item>
          <Form.Item name="email" hidden>
            <Input />
          </Form.Item>
          <Form.Item
            name="mobile"
            label={<label className="label_login">Mobile</label>}
            rules={[
              {
                required: true,
                message: "Mobile is required",
              },
              {
                pattern:
                  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
                message: "Mobile should be number only",
              },
            ]}
          >
            <Input
              addonBefore={<MobileOutlined />}
              size="large"
              placeholder=""
            />
          </Form.Item>
        </Form>
      </Modal>




      <Modal
        width="600px"
        title="Update APIs Sandbox Account"
        visible={updateModalVisible}
        onOk={() => {
          UpdateForm.validateFields()
            .then((values) => {
              UpdateForm.resetFields();
              onUpdate(values);
            })
            .catch((info) => {
              console.log("Validate Failed:", info);
            });
        }}
        onCancel={() => handleUpdateModalVisible(false)}
      >
        <Form form={UpdateForm} layout="vertical" name="form_in_modal">
          <Form.Item
            name="apiUserName"
            label={<label className="label_login">APP ID</label>}
            rules={[
              {
                required: true,
                message: "UserName is required",
              },
            ]}
          >
            <Input
              addonBefore={<UserOutlined />}
              size="large"
              readOnly
              placeholder=""
            />
          </Form.Item>
          <Form.Item
            name="apiKey"
            label={<label className="label_login">Secret Key</label>}
            rules={[
              {
                required: true,
                message: "Secret Key is required",
              },
            ]}
          >
            <Input
              addonBefore={<KeyOutlined />}
              size="large"
              readOnly
              placeholder=""
            />
          </Form.Item>
          <Form.Item
            name="agentType"
            label={<label className="label_login">API Product Type</label>}
            rules={[
              {
                required: true,
                message: "API Product Type is required",
              },
            ]}
          >
            <Input
              addonBefore={<UnorderedListOutlined />}
              size="large"
              readOnly
              placeholder=""
            />
          </Form.Item>
          <Divider />
          <p style={{ height: "30px" }}>API Product Category</p>
          <Form.Item
            name="productAccount"
            rules={[
              {
                validator: (_, value) =>
                  value && value.length > 0
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error(
                          "Please select at least one or more of Product Partner"
                        )
                      ),
              },
            ]}
          >
            <Checkbox.Group style={{ width: "100%" }}>
              <Row gutter={[16, 24]}>{option}</Row>
            </Checkbox.Group>
          </Form.Item>
        </Form>
      </Modal>

    </div>
  );
}

export default Profile;
